import { Injectable } from '@angular/core';
import { BaseHttpService } from '@nimbus-library/features/shared/services/base-http/base-http.service';
import { LocalizationPreferencesApiClient } from './localization-preferences.api-client';

@Injectable({ providedIn: 'root' })
export class AdminPortalPreferencesApiClient extends LocalizationPreferencesApiClient {
  protected readonly preferencesResource: string = 'admin-portal-preferences';

  public constructor(protected readonly baseHttpService: BaseHttpService) {
    super(baseHttpService);
  }
}
